import { useEnvironmentInterface } from "environment-interface";

import type { ProjectInfo } from "utils/git";
import { getGitHubBaseUrl } from "utils/git";

import type { Command } from "../../types";

export const useOpenRepoOnGitHubCommand = ({
  owner,
  repo,
}: ProjectInfo): Command => {
  const { navigation } = useEnvironmentInterface();

  return {
    id: "codesandbox.git.openOnGitHub",
    name: "Open on GitHub",
    section: "Integrations",
    perform: () => {
      navigation.openUrl(getGitHubBaseUrl({ owner, repo }));
    },
  };
};
